import { InjectionToken } from '@angular/core';
import type { MainMenuConfig } from './main-menu-config.type';
import type { AdminUserRole } from '@cappus/shared-common';

export const MAIN_MENU_CONFIG_TOKEN = new InjectionToken<MainMenuConfig<AdminUserRole>>(
  'MAIN_MENU_CONFIG_TOKEN',
);
